const GOOGLE_MAPS_SEARCH_URL = 'https://www.google.com/maps/search/?api=1&query=';

/**
 * Construye la URL de Google Maps para una dirección.
 * Prefiere las coordenadas GPS ("lat, lng") cuando existen, porque ubican
 * el punto exacto; si no, cae en la búsqueda por texto de la dirección.
 *
 * @param {string} address dirección en texto
 * @param {string} gps coordenadas "lat, lng"
 * @returns {string|null} URL de Google Maps o null si no hay dato usable
 */
export function getGoogleMapsUrl(address, gps) {
    const coords = (gps ?? '').split(',').map(part => part.trim());

    if (coords.length === 2 && coords.every(part => part !== '' && !isNaN(Number(part)))) {
        return `${GOOGLE_MAPS_SEARCH_URL}${encodeURIComponent(coords.join(','))}`;
    }

    const text = (address ?? '').trim();

    return text ? `${GOOGLE_MAPS_SEARCH_URL}${encodeURIComponent(text)}` : null;
}
